export const SUGARLESS_SWEETS_ID = '5d07be1b3657708b4b112803';
export const SWEETS_ID = '5cebfadbfac66126a452c9c9';
export const LIVUP_GS1_MANUFACTURER_CODE = '78986373';
